/**
 * Facebook Graph API request.
 * @constructor
 * @extends {Foundation.Promise}
 * @param {string} method
 * @param {string} path
 * @param {Object=} params
 */
Foundation.Facebook.API = function (method, path, params) {
    Foundation.Promise.call(this);
    
    if (!params) params = {};
    
    // Make sure our Facebook app has finished loading before performing
    // the API request.
    Foundation.Facebook.Application.sharedInstance().then(function () {
        FB.api(path, method, params, function (response) {
            this.fulfillWith(response);
        }.bind(this));
    }.bind(this));
};
Foundation.inherit(Foundation.Facebook.API, Foundation.Promise);

